import { useEffect } from 'react';
import { useSubmissionDetails } from '../../../pages/SubmissionDetails/SubmissionDetailsContext';
import { SUBMISSION_DETAIL_TABS } from '../../../pages/SubmissionDetails';
import { REVIEWS_TABS } from '../BoardMemberReviewsTab';
import { IDecisionModalProps } from './decisionModalHelper';

export const RequestAdjudicationAction = ({
  setActiveTab = () => {},
  onClose
}: IDecisionModalProps) => {
  const { setReviewsSubTab } = useSubmissionDetails();

  useEffect(() => {
    setActiveTab(SUBMISSION_DETAIL_TABS.REVIEWS);
    setReviewsSubTab(REVIEWS_TABS.ADJUDICATIONS);
    onClose();
  }, []);

  return <></>;
};
